export const uploadImageStyle = {
	wrapper: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		padding: '8px 0',
		textAlign: 'center',
		borderRadius: 'var(--default--border-radius)',
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%238F98A9FF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	} as any,

	image: {
		overflow: 'hidden',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		'& img': {
			objectFit: 'contain',
			height: '100%',
			width: 'auto',
		},
	},

	title: {
		fontWeight: 400,
		color: ' var(--neutral-500)',
		display: 'flex',
		alignItems: 'center',

		'& span': {
			paddingLeft: '4px',
		},
	},

	button: {
		padding: '0 4px',
		textTransform: 'none',
		fontWeight: 400,
		fontSize: '14px',
		height: '18px',
	},

	dragged: {
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%2326B5EDFF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	},

	error: {
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23FB0B24FF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	},

	errorTitle: {
		color: 'var(--error-500)',
	},

	icon: {
		svg: {
			width: '24px',
			height: '24px',
		},

		marginBottom: '8px',
	},

	errorIcon: {
		'& path': {
			fill: 'var(--error-500) !important',
		},
	},

	disabled: {
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23F0F1F4FF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	},

	disabledTitle: {
		color: 'var(--neutral-200)',
	},

	disabledIcon: {
		'& path': {
			fill: 'var(--neutral-200)',
		},
	},
};
